import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  SEARCH_SEARCH_GENRES_AND_THEMES_SET_DATA,
  SEARCH_SEARCH_GENRES_AND_THEMES_RESET_DATA,
} from 'rebook/apps/search/constants';


export function fetchInitialData(location = {}) {
  return async(dispatch) => {
    let newState = {};

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
        isLoading: false,
      };
    }
    const shouldFetchBooks = !(newState.nichesList || newState.genresList || newState.tagsList);
    const updateSeoMeta = !shouldFetchBooks;

    dispatch(setData(newState, updateSeoMeta));

    if (shouldFetchBooks) {
      await dispatch(fetchItems());
    }
  };
}

export function fetchItems() {
  return async(dispatch, getState) => {
    const { ssr, searchGenresThemes: currentState } = getState();
    const query = get(ssr, 'query.q', currentState.query);

    if (!query) {
      dispatch(setData({ isLoading: false }));
      return;
    }

    dispatch(setData({ isLoading: true }));

    let queryParams = {
      q: query,
      niches_limit: 5,
      genres_limit: 5,
      tags_limit: 5,
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/search/?${qs}`;
    return await fetchQuery(url, { apiVersion: 5, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({
          genresList: data.genres,
          nichesList: data.niches,
          tagsList: data.tags,
          genresThemesCount: data.genres.length + data.niches.length + data.tags.length,
          query,
          isLoading: false,
        }));
      })
      .catch(({ data, resp, error }) => {
        if (resp.status === 404) {
          dispatch(Error404Actions.show());
        }
        else {
          const errorText = 'failed to load themes, genres and tags due to server error';
          Raven.captureMessage(errorText, {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error(errorText);
        }
      });
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { ssr, searchGenresThemes: currentState } = getState();
    const query = get(ssr, 'query.q', currentState.query);
    const title = `Все жанры и темы по запросу «${query}»`;

    dispatch(SeoActions.setData({
      title,
    }));
  };
}

export function setData(payload, updateSeoMeta=false) {
  return (dispatch) => {
    dispatch({
      type: SEARCH_SEARCH_GENRES_AND_THEMES_SET_DATA,
      payload,
    });
    if (updateSeoMeta) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: SEARCH_SEARCH_GENRES_AND_THEMES_RESET_DATA,
    });
  };
}
